import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row, Modal } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import {
  setDevelopPlantingSite,
  setShowEditControl
} from 'reducers/livingCarbonGrantReducer';
import ActionButton from 'components/common/ActionButton';
import FalconCloseButton from 'components/common/FalconCloseButton';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';

const trees = [
  {
    id: 0,
    name: 'Hickory wattle',
    sname: 'Acacia implexa', // scientific name
    type: 'tree'
  },
  {
    id: 1,
    name: 'Mountain hickory',
    sname: 'Acacia penninervis',
    type: 'tree'
  },
  {
    id: 2,
    name: 'Kurrajong',
    sname: 'Brachychiton populneus',
    type: 'tree'
  },
  {
    id: 3,
    name: 'Box leaf wattle',
    sname: 'Acacia buxifolia',
    type: 'shrub'
  }
];

const Planting = ({ editRef }) => {
  const dispatch = useDispatch();

  // after drawing tree boundary, user input details such as quantity etc..
  const { developPlantingSite, plantingSites } = useSelector(
    state => state.livingCarbonGrant
  );

  // user selects the type of trees to plant
  const [showAddTreeModal, setShowAddTreeModal] = useState(false);
  const handleShowAddTreeModal = () => setShowAddTreeModal(true);

  const closeAddTreeModal = () => {
    setShowAddTreeModal(false);
  };

  // exit out of planting site development
  const handleClose = () => {
    dispatch(setDevelopPlantingSite(-1));
  };

  const columns = [
    {
      accessorKey: 'name',
      header: 'Name',
      meta: {
        headerProps: { className: 'text-900' }
      }
    },
    {
      accessorKey: 'sname',
      header: 'Scientific Name',
      meta: {
        headerProps: { className: 'text-900' }
      }
    },
    {
      accessorKey: 'type',
      header: 'Type',
      meta: {
        headerProps: { className: 'text-900' }
      }
    },
    {
      accessorKey: 'add',
      header: 'Add',
      cell: ({ row }) => {
        return (
          <ActionButton
            icon="plus"
            title="Delete"
            variant="action"
            className="p-0"
            onClick={() => {
              dispatch(setShowEditControl(true));
              closeAddTreeModal();
              setTimeout(() => {
                editRef.current._toolbars.draw._modes.polygon.handler.enable();
              }, 150);
            }}
          >
            Delete
          </ActionButton>
        );
      }
    }
  ];

  const getCurrentPlantingSite = id => {
    for (let i = 0; i < plantingSites.length; i++) {
      if (plantingSites[i].id === id) {
        return plantingSites[i];
      }
    }
  };

  const plantingCurrentSite = useMemo(
    () => getCurrentPlantingSite(developPlantingSite),
    [developPlantingSite]
  );

  const table = useAdvanceTable({
    data: trees,
    columns,
    sortable: true,
    pagination: true,
    perPage: 5
  });

  return (
    <>
      <Modal
        show={showAddTreeModal}
        onHide={closeAddTreeModal}
        aria-labelledby="side-name-modal"
        backdrop="static"
        centered
      >
        <Modal.Header>
          <Modal.Title id="side-name-modal">Add trees</Modal.Title>
          <FalconCloseButton
            onClick={() => {
              setShowAddTreeModal(false);
              closeAddTreeModal();
            }}
          />
        </Modal.Header>
        <Modal.Body>
          {' '}
          <AdvanceTableProvider {...table}>
            <Row className="flex-end-center mb-3">
              <Col xs="auto" sm={6} lg={4}>
                <AdvanceTableSearchBox />
              </Col>
            </Row>
            <AdvanceTable
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
              tableProps={{
                bordered: true,
                striped: true,
                className: 'fs-10 mb-0 overflow-hidden'
              }}
            />
            <div className="mt-3">
              <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
            </div>
          </AdvanceTableProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            type="submit"
            className="mt-3"
            onClick={() => closeAddTreeModal()}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <h2>
        {plantingCurrentSite.name} ({developPlantingSite})
      </h2>
      <Button variant="primary" onClick={handleShowAddTreeModal}>
        Add Tree
      </Button>
      <br />
      <br />

      {/* {groupedSpecies && */}
      {/*   groupedSpecies.map(site => { */}
      {/*     return ( */}
      {/*       <> */}
      {/*         <h5>Planting site name: {site.siteId}</h5> */}
      {/*         {site.species && */}
      {/*           site.species.map(s => { */}
      {/*             return ( */}
      {/*               <> */}
      {/*                 <span>Tree Name: {s.name}</span> */}
      {/*                 <br /> */}
      {/*                 <span>Amount of Landuse: </span> */}
      {/*                 <br /> */}
      {/*                 <span>Feet apart for each tree: </span> */}
      {/*                 <Form.Control type="number" placeholder="0" /> */}
      {/*                 <br /> */}
      {/*                 <span>Number of trees base on land: </span> */}
      {/*                 <Form.Control type="number" placeholder="0" /> */}
      {/*                 <hr /> */}
      {/*               </> */}
      {/*             ); */}
      {/*           })} */}
      {/*       </> */}
      {/*     ); */}
      {/*   })} */}

      <Button variant="primary" onClick={handleClose}>
        Done
      </Button>
    </>
  );
};

Planting.propTypes = {
  editRef: PropTypes.object.isRequired
};
export default Planting;
